import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { Fleet } from './FleetMenu';

import { Icon } from '@liftango/ui-icons';
interface FleetContextMenuProps {
  contextMenu: { x: number; y: number; fleet: Fleet } | null;
  onClose: () => void;
  onDuplicate: (fleet: Fleet) => void;
}

export default function FleetContextMenu({ contextMenu, onClose, onDuplicate }: FleetContextMenuProps) {
  const { t } = useTranslation('mapCore');
  if (!contextMenu) return null;

  const handleDuplicate = () => {
    onDuplicate(contextMenu.fleet);
    onClose();
  };

  return (
    <Menu
      open={Boolean(contextMenu)}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={contextMenu ? { top: contextMenu.y, left: contextMenu.x } : undefined}
      PaperProps={{ sx: { boxShadow: 3, minWidth: 160 } }}
    >
      <MenuItem onClick={handleDuplicate}>
        <ListItemIcon>
          <Icon name="clipboard" size={20} />
        </ListItemIcon>
        <ListItemText>{t('fleetMenu.contextMenu.duplicate')}</ListItemText>
      </MenuItem>
    </Menu>
  );
}
